<div class="card card-cascade d-print-block-visible">
  <div class="view gradient-card-header primary-gradient white-text">
      <h3 class='h3-responsive text-center'>{{getTitle()}}</h3>
  </div>
  <div class="card-body">
      <div class="report-print-page mb-3 row" 
      [id]="getScaleResultNavigatorId(scaleResult)" 
      [ngClass]="{'force-page-break':shouldPrintBreak(index), 'mb-3': !last}"
      *ngFor="let scaleResult of ScaleResults;index as index; last as last;">
          <div class="col">
                  <div class="card card-cascade">
                      <div class="view gradient-card-header secondary-gradient white-text">
                              <h3 class='h3-responsive text-center'>{{scaleResult.scale?.name}} (Scored {{scaleResult.score}} / {{scaleResult.scale.getMaxScore()}})</h3>
                      </div>
                      <div class="card-body pt-1 pt-md-3">
                          <div class="row justify-content-center" *ngIf="scaleResult.range?.hasMedia()">
                              <div class="col-8 ml-auto mr-auto">
                                <video [src]="scaleResult.range.mediaURL" controls="" class="embed-responsive"></video>
                              </div>
                          </div>
                          <div class="row justify-content-center" *ngIf="!SkipGraph">
                              <div class="col-8 ml-auto mr-auto">
                                  <app-summary-scales-chart class="card card-body row pt-1 pt-md-3" [showNames]="false" [scaleResults]="[scaleResult]" 
                                  [showRangeScore]="ShowRangeScore"
                                  [reverseDirection]="shouldReverseScaleGraph(scaleResult)"></app-summary-scales-chart>
                              </div>
                          </div>
                          <div class="row mb-0 mt-3" *ngIf="!SkipContent">
                              <div *ngIf="hasContent(scaleResult)" class="p-2">
                                  <div [innerHTML]="getContent(scaleResult)"></div>
                              </div>
                          </div>
                          <div class="row" *ngIf="shouldShowQuestionList(scaleResult)">
                              <app-scale-questions-list  class="col-12 d-report-print-page" 
                              [QuestionActions]="getActionByScale(scaleResult.scale)"
                              [Questions]="getQuestionsForScaleResult(scaleResult)"></app-scale-questions-list>
                          </div>
                          <div class="row" *ngIf="shouldShowSubScalesList(scaleResult)">
                              <dac-scale-sub-list class="col-12 d-report-print-page" [SubScales]="getSubScales(scaleResult)"></dac-scale-sub-list>
                          </div>
                      </div>
                  </div>
          </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/report-items/client-scale-results/client-scale-results.component.html